import React, { useState } from "react";
import { arrayOf, node, func, shape, string } from "prop-types";

const StateMachine = ({ initialStateId, states, onNextState, onPrevState }) => {
  if (states.length === 0) {
    throw new Error(`'states' prop can not be an empty array!`);
  }

  const firstStateId = states[0].id;
  const [currentStateId, setCurrentStateId] = useState(
    initialStateId ?? firstStateId
  );

  const currentState = states.find(({ id }) => id === currentStateId);

  if (!currentState) {
    throw new Error(`Couldn't find state with id '${currentStateId}'`);
  }

  const currentComponent = currentState.component;

  const callback = nextStateFn => config => {
    if (typeof config !== "object" || config === null) {
      config = {};
    }

    const stateIds = states.map(({ id }) => id);
    const nextStateId = nextStateFn(currentStateId, config);

    if (!stateIds.includes(nextStateId)) {
      throw new Error(
        `StateMachine event functions must return valid state ID!\n` +
          `Received '${nextStateId}' but expected one of:\n` +
          ` - ${stateIds.join("\n - ")}`
      );
    }

    setCurrentStateId(nextStateId);
  };

  return React.cloneElement(currentComponent, {
    onNextState: callback(onNextState),
    onPrevState: callback(onPrevState),
  });
};

StateMachine.propTypes = {
  states: arrayOf(
    shape({
      id: string,
      component: node,
    })
  ).isRequired,
  onPrevState: func.isRequired,
  onNextState: func.isRequired,
  initialStateId: string,
};

export default StateMachine;
